import React from 'react';

const initialState = {
  notification: "",
  error: "",
  classes: {
    title: 'text-blue-bannerTitle',
    text: 'text-blue-bannerParagraph',
    icon: 'text-blue-800',
    bg: 'bg-blue-banner',
  },
  isError: false,
  showNotification: false,
  title: 'Info',
}

const NotificationContext = React.createContext({
  state: initialState,
  dispatch: () => null
});

const notificationReducer = (state, action)  => {
  switch(action.type) {
    case "notification/message":
    case "show_notification":
      console.log('called notificaiton');
      return {
        ...state,
        showNotification: true,
        // class: "relative bg-convoy-notification",
        classes: {
          title: 'text-blue-bannerTitle',
          text: 'text-white',
          icon: 'text-blue-800',
          bg: 'bg-blue-500',
        },
        isError: false,
        notification: action.payload.message,
        title: 'Info',
      }

    case "notification/error":
    case "show_error":
      return {
        ...state,
        showNotification: true,
        // class: "relative bg-convoy-error",
        classes: {
          title: 'text-convoy-notificationErrorTitle',
          text: 'text-convoy-notificationErrorText',
          icon: 'text-convoy-notificationErrorIcon',
          bg: 'bg-convoy-notificationErrorBg',
        },
        isError: true,
        notification: action.payload.message,
        title: 'Error'
      }

    case "notification/hide":
      return {
        ...state,
        showNotification: false
      }

    default:
      return state;
  }
}

const NotificationProvider = ({children}) => {
  const [state, dispatch] = React.useReducer(notificationReducer, initialState);
  const value = [state, dispatch];

  return <NotificationContext.Provider value={value}>{children}</NotificationContext.Provider>

}

function useNotification() {
  const context = React.useContext(NotificationContext)
  if (context === undefined) {
    throw new Error("useNotification must be invoked within a NotificationProvider")
  }

  return context;
}

export { NotificationProvider, NotificationContext, useNotification }
